import React, { PureComponent } from 'react'
import { Table, Collapse } from 'react-bootstrap'
import { formatTimeString } from '../../utils/formatters'

class IdPhoneNumbers extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      open: true,
    }
  }

  render() {
    const chevronClass = this.state.open ? 'fa fa-chevron-down' : 'fa fa-chevron-right'
    const borderRadius = this.state.open ? '10px 10px 0 0' : '10px 10px 10px 10px'

    return (
      <div className='ibox float-e-margins animated fadeIn section-shadow'>
        <div
          onClick={() => this.setState({ open: !this.state.open })}
          className='ibox-title'
          style={{ borderRadius: borderRadius, cursor: 'pointer' }}
        >
          <i style={{ width: '10px' }} className={chevronClass} />
          <header>Phone Numbers</header>
        </div>
        <Collapse in={this.state.open}>
          <div>
            <div style={{ borderRadius: '0 0 10px 10px' }} className='ibox-content table-responsive'>
              {this.props.data && this.props.data.length ? (
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>Phone Number</th>
                      <th>Created</th>
                      <th>Updated</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.data.map((entry) => (
                      <tr key={entry.id}>
                        <td>{entry.id}</td>
                        <td>{entry.phone_number}</td>
                        <td>{formatTimeString(entry.created)}</td>
                        <td>{formatTimeString(entry.updated)}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <span>{'N/A'}</span>
              )}
            </div>
          </div>
        </Collapse>
      </div>
    )
  }
}

export default IdPhoneNumbers
